// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"Placeholder_placeholder__1dWlD","logo":"Placeholder_logo__6y6bK","slider":"Placeholder_slider__3N3Sp"};